import HelpContent from './helpContent';
import { Routes } from '../constants/routes';
import BaseHelpPage from '@base/features/help/components/baseHelpPage';

const HelpPage = () => {
  return (
    <BaseHelpPage routes={Object.values(Routes)}>
      <HelpContent />
    </BaseHelpPage>
  );
};
export default HelpPage;

